import {
  flow,
  isLengthEq,
  isLengthGte,
  isLengthLte,
  isNonEmptyString,
  isNumber,
  replace,
  sliceStrP,
  toLower,
  trim,
} from 'lib/utils'
import { z } from 'zod'

export let maxLimitMsg = 'Превышен лимит длины'

export let NonEmptyString = (msg = '') =>
  z
    .string()
    .transform(trim)
    .superRefine((val, ctx) => {
      if (!isNonEmptyString(val))
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          params: {
            msg,
          },
        })
    })

export let Min8String = (
  msg = 'Строка должна содержать минимум 8 символов'
) =>
  z
    .string()
    .transform(trim)
    .superRefine((val, ctx) => {
      if (!isLengthGte(8, val))
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          params: {
            msg,
          },
        })
    })

export let Max64String = (
  msg = 'Превышен лимит длины, максимум 64 символа'
) =>
  z
    .string()
    .transform(trim)
    .superRefine((val, ctx) => {
      if (!isLengthLte(64, val))
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          params: {
            msg,
          },
        })
    })

export let Max256String = (
  msg = 'Превышен лимит длины, максимум 256 символов'
) =>
  z
    .string()
    .transform(trim)
    .superRefine((val, ctx) => {
      if (!isLengthLte(256, val))
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          params: {
            msg,
          },
        })
    })

export let MaxString = (
  msg = 'Превышен лимит длины, максимум 65536 символов'
) =>
  z
    .string()
    .transform(trim)
    .superRefine((val, ctx) => {
      if (!isLengthLte(65536, val))
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          params: {
            msg,
          },
        })
    })

export let parse =
  <T, U extends z.ZodTypeAny>(x: z.ZodEffects<z.ZodEffects<U, T>>) =>
  (y: z.infer<U>) => {
    let result = x.safeParse(y)
    return result.success ? result.data : undefined
  }

export let pass =
  <T, U extends z.ZodTypeAny>(x: z.ZodEffects<U, T>) =>
  (y: z.infer<U>) => {
    let result = x.safeParse(y)
    return result.success
  }

export let NonEmptySubMaxString = NonEmptyString(
  'Это поле не должно быть пустым'
).refine(pass(MaxString()), {
  message: maxLimitMsg,
})

export let MaskedPhoneNumber = NonEmptyString(
  'Пожалуйста, введите номер телефона'
)
  .transform(flow(replace(/\D/g, ''), sliceStrP(1)))
  .superRefine((val, ctx) => {
    if (!isNumber(Number(val)) || !isLengthEq(10, val))
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        params: {
          msg: 'Некорректный номер',
        },
      })
  })

export let OTP = NonEmptyString(
  'Пожалуйста, введите код'
).superRefine((val, ctx) => {
  if (!isNumber(Number(val)) || !isLengthEq(4, val))
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      params: {
        msg: 'Некорректный код',
      },
    })
})

export let Email = NonEmptyString(
  'Пожалуйста, введите адрес электронной почты'
)
  .and(
    Max64String(
      'Адрес электронной почты слишком длинный (более 64 символов)'
    )
  )
  .and(z.string().email())
  .transform(toLower)
